export default __webpack_public_path__ + "static/media/expand.441b4538.svg";